enum DivisionStyle {
  Payment = 'payment',
  Tax = 'tax',
}

export default DivisionStyle;
